import React, {useRef, useEffect} from "react";

//hooks
import { useDrag, useDrop } from "react-dnd";

//interfaces
import { IUseTextOptionListItem } from "../../../../interfaces/lists/ITextOptionList";


const UseTextOptionListItem = ({
    index,
    hoverIndex,
    containerRef, 
    moveListItem,
    setHoverIndex, 
    dragAndDropAction,
}: IUseTextOptionListItem) => {   

    const rowRef = useRef<any>(null);
    const dragRef = useRef<HTMLButtonElement>(null);
   
    // Drag logic
    const [{ isDragging }, drag, preview] = useDrag({
        type: "ROW",
        item: { index },
        collect: (monitor) => ({ isDragging: monitor.isDragging()}),
        end: () => { setHoverIndex(null) }
    });
    
    drag(dragRef);
   
    const [, drop] = useDrop({
        accept: "ROW",
        hover(item: { index: number }) {
            if (!rowRef.current) { return }
    
            const dragIndex = item.index;
            const hoverIndex = index;
            if (dragIndex === hoverIndex) { return }
    
            moveListItem(dragIndex, hoverIndex, false);
            setHoverIndex(hoverIndex);
            item.index = hoverIndex;
        },
           
        drop() {
            setHoverIndex(null);
            dragAndDropAction?.(hoverIndex ?? 0)
        }
    });
   
    useEffect(() => {
        preview(drop(rowRef));
    }, [preview, drop]);
   
    useEffect(() => {
        document.body.style.cursor = isDragging ? "grabbing" : "inherit";
    }, [isDragging]);
   
    useEffect(() => {
        const handleDragLeave = (event: DragEvent) => {
            if (containerRef.current && !containerRef.current.contains(event.relatedTarget as Node)) {
                setHoverIndex(null);
            }
        };
        containerRef?.current.addEventListener('dragleave', handleDragLeave); 
        return () => containerRef?.current.addEventListener('dragleave', handleDragLeave); 
    }, [containerRef]);
    
    return {
        isDragging, dragRef, rowRef
    };
}

export default UseTextOptionListItem